export default {
  momentLocale: 'ru',
  Timeline: {
    expand: 'Развернуть',
    fold: 'Свернуть',
  },
  Balloon: {
    close: 'Закрыть',
    confirm: 'Ок',
    cancel: 'Отмена',
  },
  Card: {
    expand: 'Развернуть',
    fold: 'Свернуть',
  },
  Calendar: {
    today: 'Сегодня',
    now: 'В этот момент',
    ok: 'Подтвердить',
    clear: 'Очистить',
    month: 'Месяц',
    year: 'год',
    prevYear: 'Прошлый год',
    nextYear: 'следующий год',
    prevMonth: 'Прошлый Месяц',
    nextMonth: 'Следующий месяц',
    prevDecade: 'Предыдущие двенадцать лет',
    nextDecade: 'Через 12 лет',
    yearSelectAriaLabel: 'Выберите год',
    monthSelectAriaLabel: 'Выберите месяц',
    format: {
      months: '1 месяц_2 месяц_3 месяц_4 месяц_5 месяц_6 месяц_7 месяц_8 месяц_9 месяц_10 месяц_11 месяц_12 месяц'.split(
        '_',
      ),
      shortMonths: '1 месяц_2 месяц_3 месяц_4 месяц_5 месяц_6 месяц_7 месяц_8 месяц_9 месяц_10 месяц_11 месяц_12 месяц'.split(
        '_',
      ),
      weekdays: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
      shortWeekdays: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
      veryShortWeekdays: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
      yearLabel: 'г. YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Пожалуйста, выберите дату',
    datetimePlaceholder: 'Пожалуйста, выберите дату и время',
    monthPlaceholder: 'Пожалуйста, выберите месяц',
    yearPlaceholder: 'Пожалуйста, выберите год',
    now: 'Сейчас',
    selectTime: 'Выберите время',
    selectDate: 'Выберите дату',
    ok: 'Подтвердить',
    clear: 'Очистить',
    startPlaceholder: 'Начальная дата',
    endPlaceholder: 'Конечная дата',
    hour: 'Час',
    minute: 'минута',
    second: 'сек',
  },
  Dialog: {
    close: 'Закрыть',
    ok: 'Подтвердить',
    cancel: 'Отмена',
  },
  Message: {
    closeAriaLabel: 'Закрыть',
  },
  Pagination: {
    goTo: 'Перейти к',
    page: 'Страница',
    total: 'Страница {current} из {total}',
    labelPrev: 'Предыдущая страница, текущая страница {current}',
    labelNext: 'Следующая страница, текущая страница {current}',
    inputAriaLabel: 'Введите номер страницы, на которую нужно перейти',
    selectAriaLabel: 'Выберите, сколько записей отображать на странице',
    pageSize: 'Элементов/Страница',
  },
  Input: {
    clear: 'Очистить',
  },
  Select: {
    selectPlaceholder: 'Пожалуйста, выберите',
    autoCompletePlaceholder: 'Введите',
    notFoundContent: 'Нет вариантов',
    maxTagPlaceholder: 'Выбрано {selected}/{total} элементов',
  },
  Table: {
    empty: 'Нет данных',
    ok: 'Подтвердить',
    reset: 'Сбросить',
    asc: 'Возрастание',
    desc: 'В порядке убывания',
    expanded: 'Развернуто',
    folded: 'Свернуто',
    filter: 'Фильтр',
    selectAll: 'Выбрать все',
  },
  TimePicker: {
    placeholder: 'Пожалуйста, выберите время',
    startPlaceholder: 'Начальное время',
    endPlaceholder: 'Время окончания',
    clear: 'Очистить',
    hour: 'время',
    minute: 'мин',
    second: 'секунда',
  },
  Transfer: {
    items: 'элементов',
    item: 'элементов',
    moveAll: 'Переместить все',
    searchPlaceholder: 'Пожалуйста, введите',
    moveToLeft: 'Снять выбор с элемента',
    moveToRight: 'Отправить выбранные элементы',
  },
  Upload: {
    card: {
      cancel: 'Отмена',
      addPhoto: 'Загрузить изображение',
      download: 'Загрузить',
      delete: 'Удалить',
    },
    drag: {
      text: 'Нажмите или перетащите файлы в пунктирную область для загрузки',
      hint: 'Поддерживает файлы форматов docx, xls, PDF, rar, zip, PNG, JPG и другие',
    },
    upload: {
      delete: 'Удалить',
    },
  },
  Search: {
    buttonText: 'Поиск',
  },
  Tag: {
    delete: 'Удалить',
  },
  Rating: {
    description: 'Опции оценки',
  },
};
